import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IntegrationState } from '@store/reducers/integration.reducer';

export const selectIntegrationState = createFeatureSelector<IntegrationState>('integration');

export const selectIntegrationLoading = createSelector(
  selectIntegrationState,
  (state) => state?.loading
);

export const selectIntegrationList = createSelector(
  selectIntegrationState,
  (state) => state?.integrationList
);

export const selectIntegrationError = createSelector(
  selectIntegrationState,
  (state) => state?.error
);

export const selectIntegrationEditMode = createSelector(
  selectIntegrationState,
  (state) => state?.editMode
);

export const selectIntegrationIsEditing = createSelector(
  selectIntegrationState,
  (state) => state?.isEditing
);

export const selectIntegrationForm = createSelector(
  selectIntegrationState,
  (state) => state?.integrationForm
);

export const selectIntegrationId = createSelector(
  selectIntegrationState,
  (state) => state?.integrationId
);

export const selectIntegration = createSelector(
  selectIntegrationState,
  (state) => state?.integration
);
